import { ENVIRONMENT } from '@env/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export function setupTelemetry(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!ENVIRONMENT.telemetry.enabled) {
      console.log('Telemetry is disabled.');
      resolve();
      return;
    }

    const connectionString = ENVIRONMENT.telemetry.connectionString;
    if (!connectionString) {
      console.warn('Telemetry connection string is missing. Skipping setup.');
      resolve();
      return;
    }

    // Initialize Application Insights
    const appInsights = new ApplicationInsights({
      config: {
        connectionString,
        samplingPercentage: ENVIRONMENT.telemetry.sampleRate,
        enableAutoRouteTracking: true, // Tracks route changes in SPA
        enableRequestHeaderTracking: true, // Track request/response headers
        enableResponseHeaderTracking: true,
        autoTrackPageVisitTime: true, // Track page view times
        enableUnhandledPromiseRejectionTracking: true,
        // isCookieUseDisabled: true,  // Uncomment if cookies aren't allowed
      },
    });

    try {
      appInsights.loadAppInsights();
      appInsights.trackPageView();
      console.log('Application Insights telemetry initialized successfully.');
      resolve();
    } catch (error) {
      console.error('Failed to initialize Application Insights telemetry:', error);
      reject(error);
    }
  });
}
